import React, {useRef, useState} from 'react';
import AuthLayout from "../../layouts/AuthLayout";
import ButtonLong from "../../components/ButtonLong";
import TextInput from "../../components/TextInput";
import {Link, useParams} from "react-router-dom";
import Captcha from "../../components/Captcha";
import {toast} from "react-toastify";
import {useMutation} from "react-query";
import {apollo} from "../../utils/apollo";
import {RESET_PASSWORD} from "../../utils/graphql";
import PasswordStrengthIndicator from "../../components/PasswordStrengthIndicator";
import {useTranslation} from "react-i18next";

function ResetPassword() {
    const {t} = useTranslation();
    const {token} = useParams();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const recaptcha = useRef()

    const updatePasswordMutation = useMutation({
        mutationFn: async () => {
            const {data} = await apollo.mutate({
                mutation: RESET_PASSWORD,
                variables: {
                    input: {
                        token,
                        password,
                        confirm_password: confirmPassword
                    }
                },
            });
            return data?.resetPassword;
        },
        onError: ((error) => {
            if (error.graphQLErrors) {
                error.graphQLErrors.map((item) => console.log(item));
            }
        }),
        onSuccess: async (data) => {
            if (data && data.message) {
                if (data.success) {
                    toast.success(data.message);
                } else {
                    toast.error(data.message);
                }
                setTimeout(() => {
                    window.location.href = process.env.REACT_APP_PAYD_URL + `/login`;
                }, 5000)
            } else {
                toast.error(t('auth.something_went_wrong'))
            }
        },
        onSettled: async () => {
            recaptcha?.current?.reset()
        }
    })
    const updatePasswordHandler = async (e) => {
        e.preventDefault();
        const captcha = recaptcha.current?.getValue();
        if (!captcha) {
            toast.error(t('auth.verify_recaptcha'))
            return;
        }
        updatePasswordMutation.mutate();
    }

    return (
        <AuthLayout title={t('auth.update_password_title')}>
            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
                <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
                    <form className="space-y-6" action="#" method="POST">
                        <TextInput label={t('auth.password')} get={password} set={setPassword} id="password" name="password"
                                   type="password"
                                   required={true}/>
                        <PasswordStrengthIndicator password={password || ''} />

                        <TextInput label={t('auth.confirm_password')} get={confirmPassword} set={setConfirmPassword}
                                   id="confirm_password" name="confirm_password" type="password"
                                   required={true}/>

                        <div className="flex">
                            <Captcha ref={recaptcha} />
                        </div>
                        <div>
                            <ButtonLong onClick={updatePasswordHandler}
                                        disabled={updatePasswordMutation.isLoading}>{t('auth.update_button')}</ButtonLong>
                        </div>
                    </form>
                </div>

                <p className="mt-10 text-center text-sm text-gray-500">
                    {t('auth.not_a_member_yet')}{' '}
                    <Link to="/register" className="font-semibold leading-6 text-cyan-500 hover:text-cyan-500">
                        {t('auth.sign_up_here')}
                    </Link>
                </p>

                <p className="mt-2 text-center text-sm text-gray-500">
                    {t('auth.already_signed_up')}{' '}
                    <Link to="/login" className="font-semibold leading-6 text-cyan-500 hover:text-cyan-500">
                        {t('auth.go_to_login')}
                    </Link>
                </p>
            </div>
        </AuthLayout>
    );
}

export default ResetPassword;
